import gql from 'graphql-tag';

export default gql`
    query Link($input: UUID!) {
        linkById(id: $input) {
            path
            data
        }
    }
`;